import { Component, NgZone, ViewChild } from "@angular/core"
import { Subscription } from "rxjs"
import { MapMarker } from "src/app/models/marker"
import { MapService } from "src/app/services/map.service"
import { CONFIG_LINE, CONFIG_LINE_INNER } from "src/configs/map_configuration"
import { environment } from "src/environments/environment"
import { GMapComponent } from "../gmap/gmap.component"

@Component({
	selector: "app-gmap-container",
	template: ""
})
export class GMapContainerComponent {
	public popList: any[] = []
	public poiList: any[] = []
	public markersPops: MapMarker[] = []
	public markersPois: MapMarker[] = []
	public cachedCivics: any[] = []
	public newCivics: any[] = []
	public networkLines = []
	public modalBuildings = []
	public networkData: any
	public networkNationalData: any
	public popsObjList = {}
	public searchBuildingPlaceholdersSubscription$: Subscription
	public getBuildingsByCoordinatesSubscription$: Subscription
	public assets_version = environment.ASSETS_VERSION
	public geocoder = new google.maps.Geocoder()
	public typesMarkersPointsNTW = ["POINT_CIVIC", "POINT_PLACE", "POINT_PICKED", "PICKED"]
	private ZOOM_CLUSTER = 12
	public salesforceSent: boolean = false
	public place: any = null
	public isPlaceSelected = false
	public waitBuildings = false
	public wait = false
	public isValidPoint = false
	public errorCoverage = false

	@ViewChild("map", { static: true }) map: GMapComponent

	constructor(
		public mapService: MapService,
		public zone: NgZone
	) {}

	// Map events


  public onIdle(zoomLevel) {
    this.setMapButton('pops');
    this.setMapButton('poi');
    setTimeout(() => {
      this.gestKml(zoomLevel);
      this.manageBuildingsAndClusters();
    }, 100);
  }

	public populateMapDefault(zoomLevel) {
		this.getPops()
		this.gestKml(zoomLevel)
		this.getPois()
		this.getIndustrialArea()
		this.getNetworkNational()
	}

	public onClickMapButton(type) {
		this.mapService.mapButtons[type].active = !this.mapService.mapButtons[type].active
		this.setMapButton(type)
	}

	public onSelectCluster(markerCluster: MapMarker) {
		const latlng = new google.maps.LatLng(markerCluster.coordinates.lat, markerCluster.coordinates.lng)
		const zoom = this.map.map.getZoom() + 2
		this.map.zoomToCoordinates(latlng, zoom, false)
	}

	private getPops() {
		this.mapService.getPops().subscribe(res => {
			this.popList = res
			this.markersPops = []
			for (const pop of res) {
				this.popsObjList[pop.nome] = pop
				this.markersPops.push(this.mapService.popToMarker(pop))
			}
			this.setMapButton("pops")
			this.getNetwork()
		})
	}

	private getPois() {
		this.mapService.getPois().subscribe(res => {
			this.poiList = res
			this.markersPois = []
			for (const poi of res) {
				this.markersPois.push(this.mapService.poiToMarker(poi))
			}
			this.setMapButton("poi")
		})
	}

	public gestKml(zoomLevel) {
		if (zoomLevel >= this.ZOOM_CLUSTER) {
			this.map.removeKmlLayers()
		} else {
			if (
				this.mapService.activeButtonsLength !== this.mapService.activeButtons.length ||
				!this.map.kmlShown.length
			) {
				this.mapService.getKml(this.mapService.activeButtons).subscribe(res => {
					this.map.showKmlLayers(res)
					this.mapService.activeButtonsLength = this.mapService.activeButtons.length
				})
			}
		}
	}

	private getIndustrialArea() {
		const industrial_url =
			environment.BASE_KMLS_URL + "industrial-area/areas.kml?version=" + environment.KML_VERSION
		this.map.drawIndustrialLayers(industrial_url)
	}

	alreadyExists(obj, list) {
		for (let i = 0; i < list.length; i++) {
			if (list[i].id === obj.id) {
				return true
			}
		}
		return false
	}

	public manageBuildingsAndClusters() {
		this.waitBuildings = true
		this.map.removeMarkersByType("cluster")
		if (this.map.map && this.map.map.getZoom() >= this.ZOOM_CLUSTER && this.map.map.getBounds()) {
			if (this.searchBuildingPlaceholdersSubscription$ instanceof Subscription) {
				this.searchBuildingPlaceholdersSubscription$.unsubscribe()
			}
			this.searchBuildingPlaceholdersSubscription$ = this.mapService
				.searchBuildingPlaceholders(this.map.map.getBounds(), this.map.map.getZoom(), this.activeButtons())
				.subscribe(
					res => {
						const markers = []
						if (res.results) {
							if (res.cluster) {
								for (const cluster of res.results) {
									markers.push(this.mapService.cluster2Marker(cluster))
								}
								this.map.showMarkers(markers, { clearTypes: ["cluster", "FTTH", "FTTH C&D", "MAN"] })
								this.cachedCivics = []
								this.newCivics = []
							} else {
								for (const civic of res.results) {
									if (!this.alreadyExists(civic, this.cachedCivics)) {
										this.cachedCivics.push(civic)
										this.newCivics.push(civic)
									}
									this.wait = false
								}
								for (const civic of this.newCivics) {
									markers.push(this.mapService.civic2Marker(civic))
								}
								if (markers.length) {
									this.map.showMarkers(markers)
								}
							}
							this.waitBuildings = false
						}
						this.newCivics = []
					},
					err => {
						this.waitBuildings = false
					}
				)
		} else if (this.map.map && this.map.map.getZoom() < this.ZOOM_CLUSTER) {
			this.cachedCivics = []
			this.waitBuildings = false
		}
	}

	private gestBuildings(areaType) {
		if (this.mapService.activeButtons.length) {
			this.manageBuildingsAndClusters()
		} else {
			this.map.removeMarkersByAreaType(areaType)
			this.cachedCivics = []
		}
	}

	private getNetwork() {
		this.mapService.getNetwork().subscribe(res => {
			this.networkData = res
			this.networkToLines()
			this.setMapButton("network")
		})
	}

	private getNetworkNational() {
		this.mapService.getNetworkNational().subscribe(res => {
			this.networkNationalData = res
		})
	}

	private editLineColors(lines) {
		for (const entry of lines.national) {
			entry.strokeColor = lines.national_color
			entry.strokeWidth1 = lines.national_width[0]
			entry.strokeWidth2 = lines.national_width[1]
			entry.zIndex = 2
		}
		for (const entry of lines.provincial) {
			entry.strokeColor = lines.provincial_color
			entry.strokeWidth1 = 2
			entry.strokeWidth2 = 0
			entry.zIndex = 1
		}
	}

	private networkToLines() {
		this.editLineColors(this.networkData)
		const networkList = this.networkData.national.concat(this.networkData.provincial)
		for (const n of networkList) {
			const k1 = n.pops[0]
			const k2 = n.pops[1]
			const pop1 = this.popsObjList[k1]
			const pop2 = this.popsObjList[k2]
			CONFIG_LINE.strokeColor = n.strokeColor
			CONFIG_LINE.strokeWeight = n.strokeWidth1
			CONFIG_LINE_INNER.strokeWeight = n.strokeWidth2
			if (!pop1 || !pop2) {
				continue
			}
			const line_coordinates = [pop1, pop2]
			// CONFIG_LINE
			const poly_config = Object.assign(CONFIG_LINE, {
				path: line_coordinates,
				geodesic: true,
				zIndex: n.zIndex
			})
			const line_path = new google.maps.Polyline(poly_config)
			this.networkLines.push(line_path)
			// CONFIG_LINE
			const poly_config_inner = Object.assign(CONFIG_LINE_INNER, {
				path: line_coordinates,
				geodesic: true,
				zIndex: n.zIndex
			})
			const line_path_inner = new google.maps.Polyline(poly_config_inner)
			this.networkLines.push(line_path_inner)
		}
	}

	public setMapButton(type) {
		const active = this.mapService.mapButtons[type].active
		switch (type) {
			case "pops":
				if (active) {
					const zoom = this.map.map.getZoom()
					const list = this.markersPops.filter(
						m => m.range.min !== null && zoom >= m.range.min && (m.range.max == null || zoom < m.range.max)
					)
					this.map.showMarkers(list, { clearTypes: ["POP"] })
				} else {
					this.map.removeMarkersByType("POP")
				}
				break
			case "poi":
				if (active) {
					this.map.showMarkers(this.markersPois, { clearTypes: ["POI"] })
				} else {
					this.map.removeMarkersByType("POI")
				}
				break
			case "network":
				if (active) {
					this.map.showLines(this.networkLines, "network", { clearTypes: ["network"] })
				} else {
					this.map.removeLines("network")
				}
				break
			case "covered_ab":
			case "prospect":
			case "covered_cd":
				this.gestKml(this.map.map.getZoom())
				this.gestBuildings(type)
				break
		}
	}

	public activeButtons() {
		const buttons = []
		if (environment.show_agf) {
			buttons.push("CoveredAGF")
		}
		if (this.mapService.mapButtons.covered_ab.active) {
			buttons.push("CoveredAB")
		}
		if (this.mapService.mapButtons.covered_cd.active) {
			buttons.push("CoveredCD")
		}
		if (this.mapService.mapButtons.prospect.active) {
			buttons.push("Designed")
		}
		return buttons
	}

	public getSingleLabel(string) {
		const found = string.substr(0, string.indexOf("<br />"))
		return found ? found : string
	}
}
